import { render } from "./Authority.vue?vue&type=template&id=273da263&scoped=true&ts=true"
import script from "./Authority.vue?vue&type=script&lang=ts"
export * from "./Authority.vue?vue&type=script&lang=ts"

import "./Authority.vue?vue&type=style&index=0&id=273da263&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273da263"]])

export default __exports__